(function () {
  'use strict';

  /* ---------- stars ---------- */
  var starsEl = document.getElementById('spore-stars');
  if (starsEl && !starsEl.dataset.built) {
    starsEl.dataset.built = 'true';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 70; i++) {
      var s = document.createElement('span');
      s.className = 'star';
      var size = (Math.random() * 1.8 + 0.8).toFixed(1);
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      s.style.left = (Math.random() * 100).toFixed(2) + '%';
      s.style.top = (Math.random() * 100).toFixed(2) + '%';
      s.style.animationDelay = (Math.random() * 4).toFixed(2) + 's';
      s.style.animationDuration = (3 + Math.random() * 3).toFixed(2) + 's';
      frag.appendChild(s);
    }
    starsEl.appendChild(frag);
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = document.getElementById('spore-menu-open');
  var mobileMenu = document.getElementById('spore-mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- category pill filter (homepage product grid) ---------- */
  document.querySelectorAll('.cat-pill[data-filter]').forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      var cards = document.querySelectorAll('[data-product-group]');
      if (!cards.length) return;
      e.preventDefault();
      document.querySelectorAll('.cat-pill[data-filter]').forEach(function (p) {
        p.classList.remove('active');
      });
      pill.classList.add('active');
      var filter = pill.dataset.filter;
      cards.forEach(function (card) {
        card.style.display = (filter === 'all' || card.dataset.productGroup === filter) ? '' : 'none';
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var qtyEl = stepper.querySelector('.qty');
    var minus = stepper.querySelector('.qty-minus');
    var plus = stepper.querySelector('.qty-plus');
    if (!qtyEl || !minus || !plus) return;

    // giữ ô quantity ẩn khớp với bộ đếm, để nút thanh toán nhanh gửi đúng số lượng
    function syncHiddenQty() {
      var form = stepper.closest('form');
      var hidden = form ? form.querySelector('input[name="quantity"]') : null;
      if (hidden) hidden.value = parseInt(qtyEl.textContent, 10) || 1;
    }

    minus.addEventListener('click', function () {
      var v = parseInt(qtyEl.textContent, 10) || 1;
      if (v > 1) qtyEl.textContent = v - 1;
      syncHiddenQty();
    });
    plus.addEventListener('click', function () {
      var v = parseInt(qtyEl.textContent, 10) || 1;
      if (v < 20) qtyEl.textContent = v + 1;
      syncHiddenQty();
    });
  });

  /* ---------- Shopify AJAX cart ---------- */
  var cartBadge = document.getElementById('spore-cart-badge');
  var cartItemsEl = document.getElementById('spore-cart-items');
  var cartTotalEl = document.getElementById('spore-cart-total');
  var cartDrawer = document.getElementById('spore-cart-drawer');
  var cartOverlay = document.getElementById('spore-cart-overlay');
  var cartToast = document.getElementById('spore-cart-toast');

  var cartCurrency = null;

  function moneyFormat(cents, currency) {
    var code = currency || cartCurrency || window.SPORE_CURRENCY || 'USD';
    try {
      return new Intl.NumberFormat(window.SPORE_LOCALE || 'en', {
        style: 'currency', currency: code
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
  }
  function showToast(msg) {
    if (!cartToast) return;
    cartToast.textContent = msg;
    cartToast.classList.add('show');
    clearTimeout(cartToast._t);
    cartToast._t = setTimeout(function () {
      cartToast.classList.remove('show');
    }, 2200);
  }

  var openBtn = document.getElementById('spore-cart-open');
  var closeBtn = document.getElementById('spore-cart-close');
  if (openBtn) openBtn.addEventListener('click', function () { refreshCart(); openCart(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* thanh "còn bao nhiêu nữa là free ship", chỉ hiện khi nước khách có mốc free ship */
  function renderShipMeter(cart) {
    var meter = document.getElementById('spore-ship-meter');
    if (!meter) return;
    var limit = (window.SPORE_FREE_SHIP || {})[window.SPORE_COUNTRY];
    if (!limit || !cart.items.length || (cart.currency && cart.currency !== 'USD')) {
      meter.hidden = true;
      return;
    }
    var left = limit - cart.total_price;
    document.getElementById('spore-ship-msg').textContent = left > 0
      ? 'You are ' + moneyFormat(left) + ' away from free US shipping.'
      : 'Nice, your order ships free.';
    document.getElementById('spore-ship-fill').style.width = Math.min(100, cart.total_price / limit * 100) + '%';
    meter.classList.toggle('is-done', left <= 0);
    meter.hidden = false;
  }

  function renderCart(cart) {
    if (!cartItemsEl || !cartTotalEl || !cartBadge) return;
    cartBadge.textContent = cart.item_count;
    if (cart.currency) cartCurrency = cart.currency;
    cartTotalEl.textContent = moneyFormat(cart.total_price);
    renderShipMeter(cart);

    if (!cart.items.length) {
      cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty. Add a mushroom to get started.</p>';
      return;
    }
    cartItemsEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cart-item';
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : '';

      // dòng tuỳ chọn khách tự điền (vd: Custom letters: ABC)
      var propsHtml = '';
      Object.keys(item.properties || {}).forEach(function (key) {
        if (key.charAt(0) === '_') return; // thuộc tính ẩn
        var val = item.properties[key];
        if (!val) return;
        propsHtml += '<div class="ci-prop"><span>' + escapeHtml(key) + ':</span> ' + escapeHtml(String(val)) + '</div>';
      });

      row.innerHTML =
        (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="50" height="50">' : '') +
        '<div class="ci-body">' +
          '<div class="ci-name">' + escapeHtml(item.product_title) + '</div>' +
          propsHtml +
          '<div class="ci-variant-slot"></div>' +
          '<div class="ci-row-bottom">' +
            '<div class="ci-stepper">' +
              '<button type="button" class="qty-minus" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="qty">' + item.quantity + '</span>' +
              '<button type="button" class="qty-plus" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="ci-price">' + moneyFormat(item.price) + ' each</span>' +
          '</div>' +
        '</div>' +
        '<button class="ci-remove" data-key="' + escapeHtml(item.key) + '" type="button">Remove</button>';
      cartItemsEl.appendChild(row);

      // quantity stepper wired straight to the cart
      var qtyEl = row.querySelector('.qty');
      row.querySelector('.qty-minus').addEventListener('click', function () {
        var v = (parseInt(qtyEl.textContent, 10) || 1) - 1;
        if (v < 1) { changeItem(item.key, 0); return; }
        qtyEl.textContent = v;
        changeItem(item.key, v);
      });
      row.querySelector('.qty-plus').addEventListener('click', function () {
        var v = (parseInt(qtyEl.textContent, 10) || 1) + 1;
        qtyEl.textContent = v;
        changeItem(item.key, v);
      });

      // let the shopper switch to a different option of the same product
      if (!item.product_has_only_default_variant) {
        var slot = row.querySelector('.ci-variant-slot');
        fetch('/products/' + item.handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var sel = document.createElement('select');
            sel.className = 'ci-variant-select';
            product.variants.forEach(function (v) {
              var opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v.title;
              if (v.id === item.variant_id) opt.selected = true;
              sel.appendChild(opt);
            });
            sel.addEventListener('change', function () {
              var newId = sel.value;
              if (String(newId) === String(item.variant_id)) return;
              var qty = parseInt(qtyEl.textContent, 10) || 1;
              var carried = item.properties || {};
              var hasCarried = Object.keys(carried).some(function (k) { return k.charAt(0) !== '_' && carried[k]; });
              var target = null;
              product.variants.forEach(function (v) { if (String(v.id) === String(newId)) target = v; });

              // option cần khách tự điền mà chưa có gì -> đưa về trang sản phẩm thay vì thêm thiếu thông tin
              if (target && /custom letters|custom text/i.test(target.title) && !hasCarried) {
                window.location.href = '/products/' + item.handle + '?variant=' + newId;
                return;
              }

              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              })
                .then(function () {
                  return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: newId, quantity: qty, properties: carried })
                  });
                })
                .then(function () { refreshCart(); })
                .catch(function () {});
            });
            slot.appendChild(sel);
          })
          .catch(function () {});
      }
    });
    cartItemsEl.querySelectorAll('.ci-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeItem(btn.dataset.key, 0);
      });
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      // trên trang sản phẩm phạm vi là <form>, trên trang chủ là thẻ sản phẩm
      var scope = btn.closest('form') || btn.closest('[data-product-group], .product-card');
      var qtyEl = scope ? scope.querySelector('.qty') : null;
      var quantity = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;

      // gom các ô properties[...] (vd: chữ cái khách đặt riêng)
      var properties = {};
      var missing = null;
      if (scope) {
        scope.querySelectorAll('[name^="properties["]').forEach(function (input) {
          if (input.disabled) return;
          var match = input.name.match(/^properties\[(.+)\]$/);
          if (!match) return;
          var value = (input.value || '').trim();
          if (!value) {
            if (input.hasAttribute('data-prop-required') && !missing) {
              missing = { el: input, msg: input.dataset.propError || ('Please fill in ' + match[1]) };
            }
            return;
          }
          properties[match[1]] = value;
        });
      }
      if (missing) {
        showToast(missing.msg);
        missing.el.focus();
        return;
      }

      var payload = { id: variantId, quantity: quantity };
      if (Object.keys(properties).length) payload.properties = properties;

      btn.disabled = true;
      var originalLabel = btn.textContent;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () {
          btn.textContent = originalLabel;
          btn.disabled = false;
          showToast('Added to cart');
          refreshCart();
          openCart();
        })
        .catch(function (err) {
          btn.textContent = originalLabel;
          btn.disabled = false;
          showToast(err.message || 'Something went wrong');
        });
    });
  });

  var checkoutBtn = document.getElementById('spore-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  refreshCart();
})();
